<script>
  import {currentUser, mainAPI} from 'root/angular-injector-provider';
  import SpinnerWithText from 'root/components/molecules/SpinnerWithText.svelte';
  import RfpManagerDropdownActions from 'rfp/rfp-manager/main/pages/components/RfpManagerDropdownActions.svelte';
  import ListOfUsersAndInvitations
    from 'vRoot/account-profile/modules/manage-users/manage-agency-users/ListOfUsersAndInvitations.svelte';
  import {listUsersService} from 'rfp/reports/chain-portal/profile/services/hotel.service';
  import {SvelteDialog} from 'root/v-app/rbServices';
  import AutoVerificationManager
    from 'vRoot/account-profile/modules/manage-users/components/AutoVerificationManagerDialog.svelte';
  import {setContext} from 'svelte';
  import Button from 'vRoot/account-profile/modules/manage-users/Button.svelte';

  export let isAdmin;

  const STATE_LOADING = 'LOADING';
  const sortByOptions = [
    {
      id: 'nameAsc',
      label: 'User\'s Name A-Z',
      order: 'asc',
      key: 'fullName'
    },
    {
      id: 'nameDesc',
      label: 'User\'s Name Z-A',
      order: 'desc',
      key: 'fullName'
    },
    {
      id: 'accountTypeAsc',
      label: 'Account Type A-Z',
      order: 'asc',
      key: 'isAdmin'
    },
    {
      id: 'accountTypeDesc',
      label: 'Account Type Z-A',
      order: 'desc',
      key: 'isAdmin'
    },
    {
      id: '#companiesAsc',
      label: 'Companies Managed - Asc',
      order: 'asc',
      key: 'managingAccounts'
    },
    {
      id: '#companiesDesc',
      label: 'Companies Managed - Desc',
      order: 'desc',
      key: 'managingAccounts'
    },
    {
      id: 'status',
      label: 'User Status',
      order: 'asc',
      key: 'status'
    }
  ];
  const isFromRfpManager = true;
  const canAccessRfpManager = true;
  const isNotAHotel = true;

  let
    account = STATE_LOADING,
    currentUserAccountId,
    users = STATE_LOADING,
    sortBy = sortByOptions[0],
    showDeactivatedUsers = false
  ;

  setContext('users', {
    reload: loadUsers,
    getAccount: () => account,
  });

  (function initialize(){
    currentUser().get()
      .then(cUser => {
        account = cUser.currentUserAccount.account;
        currentUserAccountId = cUser.currentUserAccount.id;
        return loadUsers();
      });
  })();

  function loadUsers() {
    users = STATE_LOADING;
    return mainAPI().manageAccount.listUsersAndInvitations()
      .then(response => {
        users = response.data.map(u => {
          u.managedAccountsLength = u.managedAccounts.length;
          u.type = u.isAdmin? 'Administrator' : 'Account Manager';

          if(u._id === currentUserAccountId) {
            u.currentUser = true;
          }

          return u;
        });
      });
  }

  function setSortBy(e){
    sortBy = e.detail;
  }

  function toggleShowDeactivatedUsers(){
    showDeactivatedUsers = !showDeactivatedUsers;
  }

  function openRfpManager(){
    listUsersService.openRfpManager();
  }

  function openManageCustomers(){
    listUsersService.openManageCustomers();
  }

  function createNewUser(){
    listUsersService.createAgent(account.id, false)
      .then(loadUsers);
  }

  function manageAutoVerification(){
    SvelteDialog.show(AutoVerificationManager, {account})
      .then(r => {
        account.userAutoVerification = r;
      });
  }

</script>

<div class="Component">
  {#if account === STATE_LOADING}
    <SpinnerWithText />
  {:else}
    <div class="Header">
      <div class="HeaderDetails">
        <div class="Logo">
          {#if account.logo}
            <img
              src="{`/images/logos/${account.logo}`}"
              alt="Account Logo"
            >
          {:else}
            <div>
              <i class="material-icons">business</i>
            </div>
          {/if}
        </div>
        <div class="flex column">
          <div class="Title">
            {account.name}
          </div>
          <div class="SubTitle">
            Users & Permissions
          </div>
        </div>
      </div>
      <div class="HeaderActionsContainer">
        <div class="HeaderSort">
          <RfpManagerDropdownActions
            items="{sortByOptions}"
            mode="Light"
            grow="{true}"
            on:input={setSortBy}
          >
          <span slot="value"
                class="SortBy"
                data-icon-before="sort">
            Sort By:&nbsp;<b>{sortBy.label}</b>
          </span>
          </RfpManagerDropdownActions>
        </div>

        <div class="HeaderActions">
          {#if isFromRfpManager}
            {#if canAccessRfpManager}
              <Button
                icon="arrow_back"
                onClick="{openRfpManager}"
              >
                Back to RFP Manager
              </Button>
            {/if}

            <Button
              icon="business"
              onClick="{openManageCustomers}"
            >
              Customers
            </Button>
          {/if}

          {#if isAdmin}
            <Button
              icon="person_add"
              highlight="{true}"
              onClick="{createNewUser}"
            >
              Add New User
            </Button>
          {/if}
        </div>
      </div>
    </div>

    <div class="Content">
      {#if users === STATE_LOADING }
        <SpinnerWithText />
      {:else}
        <ListOfUsersAndInvitations data="{users}" {sortBy} {showDeactivatedUsers} {isAdmin} />
      {/if}
    </div>

    <div class="Footer">
      <Button
        icon="person_off"
        onClick="{toggleShowDeactivatedUsers}"
      >
        { showDeactivatedUsers ? 'Hide' : 'Show' } Deactivated Users
      </Button>

      {#if isNotAHotel}
        <div class="AutoVerification">
          <div>User Auto Verification is <span class="{account.userAutoVerification ? 'On' : 'Off'}">{ account.userAutoVerification ? 'ON' : 'OFF' }</span></div>
          <div>
            <Button onClick="{manageAutoVerification}">
              Manage Auto Verification
            </Button>
          </div>
        </div>
      {/if}
    </div>
  {/if}
</div>

<style lang="stylus">
  .Component {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: calc(100vh - 100px);
  }

  .Header {
    flex: 0 0 auto;
    padding: 20px;
    border-bottom: 1px solid #ECEFF1;
  }

  .HeaderDetails {
    display: flex;
    align-items: center;
  }

  .Logo {
    position relative;
    margin-right 10px;

    & > img, & > div{
      height: 65px;
      width: 110px;
      object-fit: contain;
      border-radius 3px;
      border 1px solid #ECEFF1;
      background: #ECEFF1;
      display: flex;
      justify-content: center;
      align-items: center;

      i.material-icons{
        font-size 50px;
      }
    }

    & > img{
      background transparent;
    }
  }

  .Title {
    font-size: 12px;
    color: #8c999f;
  }

  .SubTitle {
    font-size 20px;
  }

  .HeaderActionsContainer {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }

  .HeaderActions{
    display: flex;
  }

  .SortBy {
    display: flex;

    &:before {
      margin-right: 5px;
      font-size: 18px;
    }
  }

  .Footer {
    flex: 0 0 auto;
    padding: 20px;
    border-top: 1px solid #ECEFF1;
    display: flex;
    justify-content: space-between;

    .AutoVerification {
      display: flex;
      column-gap: 20px;
      align-items: center;
    }

    .On {
      color: #00A99D;
    }

    .Off {
      color: #f25b26;
    }
  }

  .Content {
    flex: 1 1 100%;
    overflow: auto;
  }

</style>
